"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var httpClient_1 = require("../../common/api/httpClient");
var apiRoutes_1 = require("../../common/constants/apiRoutes");
var formApi = {
    getData: function (journeyType) { return httpClient_1.default.get(apiRoutes_1.default.ENQUIRY_FORM + ("/" + journeyType)); },
    setData: function (data, journeyType) {
        return httpClient_1.default
            .post(apiRoutes_1.default.ENQUIRY_FORM + ("/" + journeyType), __assign({}, data))
            .then(function (response) { return response.data; });
    },
    createAppointment: function () { return httpClient_1.default.post(apiRoutes_1.default.CREATE_APPOINTMENT, {}); },
};
exports.default = formApi;
